import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        token: '',
		isIos: 0,   //判断是否是iOs
		clientType: 3,  //客户端类型 1-iOs， 2-安卓， 3-h5
		//"HUAWEI","OPPO","VIVO","OSS"
		versionData: {
			platform: '',
			market: '',
			versionNumber: '2.0.0',
		},
		deviceType: '',
		market: '',
    },
    mutations: {
        upHead(state, url) {
            state.head = url
        },
		setToken(state, n) {
			state.token = n
		}
    },
})



export default store



// WEBPACK FOOTER //
// ./src/store/store.js